import React from 'react';
import './styles.scss';

export default function CtaButtonLayout(props) {
  return (
    <div className={props.isDark ? 'cta-button-layout green' : 'cta-button-layout'}>{props.children}</div>
  );
}
